import type { Node, PathSegment, SearchItem } from '@deepcloud/api-deep-box'

export const useDragDropStore = defineStore('drag-drop', () => {
  const nodesBeingDragged = ref(false)
  const nodesBeingDragUploaded = ref(false)
  // target node for upload or move operations
  const targetNode = ref<Node | PathSegment | SearchItem>()

  return {
    nodesBeingDragged,
    nodesBeingDragUploaded,
    targetNode,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useDragDropStore, import.meta.hot))
}
